import EmberObject, { get } from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class InviteAdapter extends EmberObject {
  @service ajax

  find(ids = []) {
    return this.ajax.requestFromAdapter(ENV.API_ROOT + "/invites/" + ids.join(","))
  }
}
